import { useEffect, useRef } from 'react';
import { useQuestionnaireContext, useQuestionnaireFormContext } from '@/components/Questionnaire/QuestionnaireProvider';
import trackEvents from '@/helpers/trackEvents';

import getAllLinkedFieldKeys from '@/helpers/getAllLinkedFieldKeys';
import getInitialValueForLinkedFields from './getInitialValueForLinkedFields';

const HandleLinkedFields: React.FC = () => {
  const {
    fieldsById,
  } = useQuestionnaireContext();

  const {
    formMethods,
    getResponseSource,
    setValue,
  } = useQuestionnaireFormContext();

  useEffect(() => {
    trackEvents.track('HandleLinkedFields- render');
  }, []);

  const handledOnInitialLoad = useRef(new Set<string>());
  useEffect(() => {
    const fields = Object.values(fieldsById);
    fields.forEach((field) => {
      if (handledOnInitialLoad.current.has(field.key) || field.type === 'list' || field.type === 'table') {
        return;
      }
      if (field.linkedFields && field.linkedFields.length > 0) {
        const fieldTemplateKeys = getAllLinkedFieldKeys({
          field,
          fieldsById,
        });

        const initialValue = getInitialValueForLinkedFields({
          fieldKeys: fieldTemplateKeys,
          formMethods,
          getResponseSource,
        });

        if (initialValue) {
          fieldTemplateKeys.forEach((fieldTemplateKey) => {
            if (initialValue.key === fieldTemplateKey) {
              return;
            }
            handledOnInitialLoad.current.add(fieldTemplateKey);
            const thisValue = formMethods.getValues(fieldTemplateKey);
            if (thisValue !== null && thisValue !== undefined) {
              return;
            }
            setValue({ key: fieldTemplateKey, source: 'linked-field', value: initialValue.value });
          });
        }
      }
    });
  }, [fieldsById, formMethods, getResponseSource, setValue]);

  return null;
};

export default HandleLinkedFields;
